import React, { Component } from 'react'
import styles from './status-not-connected.styles'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import StatusColor from '../shared/status-color/status-color'
import StatusDesc from '../shared/status-desc/status-desc'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import Autocomplete from 'react-autocomplete'
import classNames from 'classnames'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import Tooltip from 'pobble-components/dist/tooltip'
import InfoIcon from 'react-icons/lib/fa/info-circle'

class StatusNotConnected extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      schools: [],
      provider: 'wonde'
    }
  }

  getSchools(value, cb) {
    this.props
      .onSearchChange(value)
      .then(({ data }) => this.setState({ schools: data.wonde_schools }))
  }

  render() {
    const { classes, id, statusColor, onConnect, onRequest } = this.props
    return (
      <div className={classes.container}>
        <div className={classes.status}>
          <StatusColor color={statusColor} />
          <div className={classes.content}>
            <h5 className={classes.title}>Not connected</h5>
            <div className={classes.selection}>
              <FormLabel htmlFor="provider" className={classes.label}>
                <strong>Step 1:</strong>
                &nbsp;Select a data provider
              </FormLabel>
              <FormSelect
                id="provider"
                className={classes.select}
                onChange={e => this.setState({ provider: e.target.value })}>
                <option value="wonde">Wonde</option>
                {/*<option value="groupcall">GroupCall</option>*/}
              </FormSelect>
            </div>

            {this.state.provider === 'groupcall' && (
              <div className={classes.selection}>
                <FormLabel className={classes.label}>
                  <strong>Step 3: </strong>
                  &nbsp; Request a connection
                </FormLabel>
                <Button
                  tall
                  action={() =>
                    openConfirmationDialog({
                      bodyText: `Are you sure you want request a connection with GroupCall?`,
                      confirmText: 'Yes',
                      action: () => onRequest(id)
                    })
                  }>
                  Connect
                </Button>
              </div>
            )}

            {this.state.provider === 'wonde' && (
              <>
                <div className={classes.selection}>
                  <FormLabel htmlFor="provider" className={classes.label}>
                    <strong>Step 2: </strong>
                    &nbsp;Select your school
                  </FormLabel>
                  <Autocomplete
                    inputProps={{
                      id: 'schools-autocomplete',
                      className: classes.field,
                      placeholder: 'Ex: Holywell Primary School'
                    }}
                    wrapperStyle={{ position: 'relative' }}
                    value={this.state.value}
                    items={this.state.schools}
                    getItemValue={item => item.name}
                    onSelect={(value, item) => {
                      this.setState({
                        value,
                        schools: [item],
                        selectedSchool: item
                      })
                    }}
                    onChange={(event, value) => {
                      this.setState({ value, selectedSchool: null })
                      this.getSchools(value)
                    }}
                    renderMenu={children => (
                      <div className={classes.menu}>{children}</div>
                    )}
                    renderItem={(item, isHighlighted) => (
                      <div
                        className={classNames(classes.item, {
                          [classes.highlighted]: isHighlighted
                        })}
                        key={item.wonde_id}>
                        {`
                            ${item.name}
                            ${item.city ? ' (' + item.city + ')' : ''}
                            ${item.address ? ' (' + item.address + ')' : ''}
                            ${item.postcode ? ' (' + item.postcode + ')' : ''}
                          `}
                      </div>
                    )}
                  />
                </div>
                {this.state.selectedSchool && (
                  <div className={classes.addressFields}>
                    {this.state.selectedSchool.address && (
                      <div className={classes.addressField}>
                        <FormInput
                          className={classes.addressInput}
                          value={this.state.selectedSchool.address}
                          disabled
                        />
                      </div>
                    )}
                    {this.state.selectedSchool.city && (
                      <div className={classes.addressField}>
                        {this.state.selectedSchool.city && (
                          <FormInput
                            className={classes.addressInput}
                            value={this.state.selectedSchool.city}
                            disabled
                          />
                        )}
                      </div>
                    )}
                    {this.state.selectedSchool.country && (
                      <div className={classes.addressField}>
                        {this.state.selectedSchool.country && (
                          <FormInput
                            className={classes.addressInput}
                            value={this.state.selectedSchool.country}
                            disabled
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}
                <div className={classes.selection}>
                  <FormLabel className={classes.label}>
                    <strong>Step 3: </strong>
                    &nbsp; Connect
                  </FormLabel>
                  <div>
                    {this.state.selectedSchool &&
                      !this.state.selectedSchool.usable && (
                        <Tooltip
                          content={`This school cannot be connected as Wonde does not have their MIS on it’s records. Please contact hello@pobble.com for more help.`}>
                          <InfoIcon className={classes.info} />
                        </Tooltip>
                      )}
                    <Button
                      tall
                      action={() =>
                        openConfirmationDialog({
                          bodyText: `Are you sure you want to proceed with ${this
                            .state.selectedSchool.name || 'this school'}?`,
                          confirmText: 'Yes',
                          action: () =>
                            onConnect(id, this.state.selectedSchool.wonde_id)
                        })
                      }
                      disabled={
                        !this.state.selectedSchool ||
                        (this.state.selectedSchool &&
                          !this.state.selectedSchool.usable)
                      }>
                      Connect
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
          <StatusDesc>
            Synchronise pupils and groups with your MIS. Refer to{' '}
            <a
              href="https://help.pobble.com/knowledge/how-can-i-add-pupils-to-pobble-via-our-school-mis"
              target="_blank"
              rel="noopener noreferrer">
              our FAQ
            </a>{' '}
            for more information.{' '}
          </StatusDesc>
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(StatusNotConnected)
